import React from "react";
import cx from "classnames";
import { useToggleMenu } from "src/context/storeContext";
import * as styles from "./hamburger.module.css";

export const Hamburger = ({ open, className, onClick }) => {
  const toggleMenu = useToggleMenu();
  return (
    <button
      onClick={onClick}
      className={cx(
        "reset",
        styles.hamburger,
        styles.hamburgerSqueeze,
        open && styles.isActive,
        className
      )}
      type="button"
      aria-label="Toggle Main Menu"
      aria-haspopup="true"
      aria-expanded={open}
    >
      <span className={styles.hamburgerBox}>
        <span className={styles.hamburgerInner} />
      </span>
    </button>
  );
};
